import reactIs_production_min from '../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.production.min.js';

var require$$0 = reactIs_production_min;

export { require$$0 as default };
//# sourceMappingURL=react-is.production.min.js_commonjs-proxy.js.map
